import React, { useEffect, useState } from 'react'
import { OnboardingView } from '../../views';
import { CatalogService, CompanyService, LocalStorageService, MessageService, OnboardingUserService } from '../../../services';
import ValidateOTPForm from '../../views/onboarding/steps/validateOtpForm';
import PersonalDataForm from '../../views/onboarding/steps/personalDataForm';
import CompanyDataForm from '../../views/onboarding/steps/companyDataForm';
import SummaryView from '../../views/onboarding/steps/summaryView';
import { ModalUtil } from '../../pures';
import { useTranslation } from 'react-i18next';
import { CompanyDataInfo } from '../../../assets/logos/icons';

const url = process.env.REACT_APP_ETICKET_API;
const localStorageService = new LocalStorageService();

// La sesión se lee en cada handler (no en el scope del módulo): este módulo se
// importa de forma eager desde routes/index.js, antes de que exista el login.
const getToken = () => localStorageService.getLocalStorageItem("token")?.idToken

const catalogService = new CatalogService(url);
const messageService = new MessageService(url);
const companyService = new CompanyService(url);
const onboardingUserService = new OnboardingUserService(url)

function OnboardingAction() {
    const [user, setUser] = useState(null);

    const { t } = useTranslation();
    const modalUtil = new ModalUtil()
    const [loading, setLoading] = useState(true)
    const [errorMessage, setErrorMessage] = useState("")
    const [currentStep, setCurrentStep] = useState(0)
    const [dataBusiness, setDataBusiness] = useState()

    const [catalog, setCatalog] = useState()

    const stepsStepper = [
        {
            icon: "k-i-email"
        }, {
            icon: "k-i-user"
        }, {
            image: CompanyDataInfo
        }, {
            icon: "k-i-check"
        }
    ]
    const stepsContent = [
        {
            number: 0,
            component: ValidateOTPForm,
            name: "validateOTP"
        },
        {
            number: 1,
            component: PersonalDataForm,
            name: "personalData"
        },
        {
            number: 2,
            component: CompanyDataForm,
            name: "companyData"
        },
        {
            number: 3,
            component: SummaryView,
            name: "summary"
        },
    ];

    const getCatalog = async () => {
        const data = await catalogService.getOnboardingResources(getToken());
        setCatalog(data);
        setLoading(false);
    }

    const moveStep = (valueOrForward) => {
        window.scroll(0, 0)
        if (typeof valueOrForward === "boolean") {
            setCurrentStep(prev => valueOrForward ? prev + 1 : prev - 1)
        } else {
            setCurrentStep(valueOrForward)
        }
    }

    const onReSendMessage = async () => {
        try {
            modalUtil.showModal('loading', t("modal.pure.loading.message"), t("modal.pure.loading.title"))
            await messageService.sendEmailMessage(user.email, getToken());
            modalUtil.showModal('success', t("register.sendCodeSuccess"), t('modal.pure.title.success'))
        } catch (error) {
            modalUtil.showModal('error', t("register.sendCodeErrror"), error.message || t("modal.pure.title.error"))
        }
    }

    const validateOTP = async (codeEntered) => {
        try {
            modalUtil.showModal('loading', t("modal.pure.loading.message"), t("modal.pure.loading.title"))
            const codeValidator = await messageService.validateEmailMessage(
                user.email,
                codeEntered,
                getToken()
            );
            if (codeValidator.data === "Validated") {
                await modalUtil.showModal('success', t("register.codeValidationSuccess"), t('modal.pure.title.success'))
                moveStep(true)
            } else {
                throw new Error(codeValidator.data)
            }
        } catch (error) {
            modalUtil.showModal('error', t("register.codeValidationError"), error.message || t("modal.pure.title.error"))
        }
    }

    const validatePersonalData = async (personalData) => {
        try {
            modalUtil.showModal('loading', t("modal.pure.loading.message"), t("modal.pure.loading.title"))
            await companyService.updateUserProfile(personalData, getToken())
            await modalUtil.showModal('success', t("register.updateDataSuccess"), t('modal.pure.title.success'))

            const userLocalStorage = localStorageService.getLocalStorageItem("user")
            userLocalStorage.userMetaData.userA3Cloud = { ...userLocalStorage.userMetaData.userA3Cloud, ...personalData }
            localStorageService.setLocalStorageItem("user", userLocalStorage)

            setUser(prev => ({ ...prev, ...personalData }))
            moveStep(true)
        } catch (error) {
            modalUtil.showModal('error', t("register.updateDataError"), error.message || t("modal.pure.title.error"))
        }
    }

    const validateBusinessProfileData = async (data) => {
        try {
            modalUtil.showModal('loading', t("modal.pure.loading.message"), t("modal.pure.loading.title"))
            setDataBusiness(data)
            await companyService.createBusinessProfile(data, getToken())
            await modalUtil.showModal('success', t("register.updateDataSuccess"), t('modal.pure.title.success'))
            moveStep(true)
        } catch (error) {
            modalUtil.showModal('error', t("register.updateDataError"), error.message || t("modal.pure.title.error"))
        }
    }

    const goToApp = () => {
        window.location.reload();
    }

    const onSubmitStep = (data) => {
        switch (stepsContent[currentStep].name) {
            case "validateOTP":
                validateOTP(data);
                break;
            case "personalData":
                validatePersonalData(data)
                break;
            case "companyData":
                validateBusinessProfileData(data)
                break;
            case "summary":
                goToApp();
                break;
        }
    }

    const getAndSetCurrentStep = async () => {
        try {
            let currentStep = await onboardingUserService.getStepOnboardingAdmin(getToken())
            if (currentStep?.statusCode === 200) {
                currentStep = currentStep.data
                if (currentStep?.stepOnboarding) setCurrentStep(currentStep?.stepOnboarding?.order)
            }
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        getCatalog();
        getAndSetCurrentStep()

        const userLocalStorage = localStorageService.getLocalStorageItem("user")
        if (userLocalStorage && userLocalStorage.userMetaData) {
            setUser(userLocalStorage.userMetaData.userA3Cloud);
        }
    }, [])

    return (
        <OnboardingView
            loading={loading}
            errorMessage={errorMessage}
            user={user}
            catalog={catalog}
            stepsStepper={stepsStepper}
            stepsContent={stepsContent}
            moveStep={moveStep}
            currentStep={currentStep}
            dataBusiness={dataBusiness}
            onSubmitStep={onSubmitStep}
            onReSendMessage={onReSendMessage}
        />
    )
}

export default OnboardingAction